import { useLiveConsultStore } from "@/App/components/liveConsult/liveConsult.store";
import { confirmationModalId, useCasesStore } from "@/Pages/Cases/store";
import { showModal } from "@/App/utils/showBootstrapModal";
import router from "@/App/router/router";
import type { RouteLocationRaw } from "vue-router";
import { toRaw } from "vue";

let approvedRoute: RouteLocationRaw = "";

export const checkForOngoingLiveConsult = (to: { path: RouteLocationRaw }): boolean => {
  const casesStore = useCasesStore();
  const liveConsultStore = useLiveConsultStore();

  if (approvedRoute === to.path) {
    approvedRoute = "";

    return true;
  }

  if (casesStore.selectedCaseId && liveConsultStore.liveConsultOn[casesStore.selectedCaseId]) {
    casesStore.confirmationModal.isModalShown = true;

    casesStore.confirmationModal.onSave = async (): Promise<void> => {
      approvedRoute = to.path;

      if (casesStore.selectedCaseId) {
        liveConsultStore.liveConsultOn[casesStore.selectedCaseId] = false;

        toRaw(liveConsultStore.startedLiveConsults[casesStore.selectedCaseId]).hangUp();
      }

      await router.push(to.path);
    };

    showModal({ modalId: confirmationModalId });

    return false;
  }

  return true;
};
